module.exports = __webpack_public_path__ + "static/img/titleImg.4f6eb0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newmember/titleImg.jpg
// module id = jKVP
// module chunks = 1